import React, { Component } from 'react'

import { Dialog } from 'primereact/dialog'
import { Button } from 'primereact/button'
import { Toolbar } from 'primereact/toolbar'

class ConfirmDialog extends Component {
  //this is a reusable confirm dialog box
  //has 'Yes' and 'No'
  //expects the following props from calling component:
  //title - text to be displayed as the title of the dialog box
  //message - text to be displayed in the content section of the dialog box
  //buttonClassName - class name of the button that will trigger the displaying of the dialog box
  //buttonLabel - button label of the button that will trigger the displaying of the dialog box
  //buttonIcon - icon of the button that will trigger the displaying of the dialog box
  //buttonIconPos - icon position of the button that will trigger the displaying of the dialog box
  //handleOnYesClick - event handler for button that will trigger the displaying of the dialog box when the user clicks 'Yes'

  //usage example (refer to components\event\EventPageActions)
  /* <ConfirmDialog title="Cancel Changes" message={"Are you sure you want to cancel the pending changes?"}
  buttonClassName="p-button-secondary left-margin" buttonLabel="Cancel Changes" buttonIcon="pi pi-times" buttonIconPos="left" handleOnYesClick={this.handleConfirmCancel} /> */


  // NOTE: had to add this in app.css, otherwise the dialog box did weird things to the page....
  // body.p-overflow-hidden {
  //   position: initial;
  // }

  constructor(props) {
    super(props)
    this.state = { visible: false } //default pop-up to be hidden
  }

  onButtonClick = event => {
    //when button with confirm dialog is clicked
    //set visible to true so the confirm dialog will be displayed
    this.setState({ visible: true })
  }

  onHide = event => {
    //when 'no' or 'x' is clicked, hide the confirm dialog
    this.setState({ visible: false })
  }

  onConfirm = event => {
    //when 'yes' is clicked, hide the confirm dialog
    //and call the event handler for 'yes' click
    this.setState({ visible: false })
    this.props.handleOnYesClick()
  }

  render() {
    const footer = (
      <Toolbar>
        <div className="p-toolbar-group-left">
          <Button label="Yes" icon="pi pi-check" type="button" onClick={this.onConfirm} />
        </div>
        <div className="p-toolbar-group-right">
          <Button label="No" icon="pi pi-times" type="button" onClick={this.onHide} className="p-button-secondary" />
        </div>
      </Toolbar>
    );
    return (
      <React.Fragment>
        <Dialog header={this.props.title} visible={this.state.visible} width="350px" modal={true} footer={footer} minY={70}
          onHide={this.onHide} maximizable={false}>
          {/* insert new lines by splitting into each section that needs a new line and adding a br tag */}
          {this.props.message.split('\n').map(messagePart => {
            return (
              <React.Fragment>
                {messagePart}
                <br />
              </React.Fragment>
            )
          })}
        </Dialog>
        <Button type="button" className={this.props.buttonClassName} label={this.props.buttonLabel} icon={this.props.buttonIcon} iconPos={this.props.buttonIconPos} onClick={this.onButtonClick} style={{margin:10}} ></Button>
      </React.Fragment>

    )
  }
}

export default ConfirmDialog


// WEBPACK FOOTER //
// ./src/components/common/ConfirmDialog.js